<script setup lang="ts">
defineProps<{
  showMapButton: boolean
  mapVisible: boolean
}>()

defineEmits<{
  'toggle-map': []
}>()
</script>

<template>
  <Transition name="fade">
    <button
      v-show="showMapButton"
      class="fixed bottom-5 left-1/2 z-50 flex w-max -translate-x-1/2 items-center rounded bg-gray-700 px-5 py-4 font-medium text-white lg:bottom-8"
      type="button"
      @click="$emit('toggle-map')"
    >
      <BaseIcon
        aria-hidden="true"
        class="mr-2.5"
        focusable="false"
        name="map"
      />
      <span v-if="!mapVisible">{{ $t('search.see_map') }}</span>
      <span v-else>{{ $t('search.close_map') }}</span>
    </button>
  </Transition>
</template>
